import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'
import *as echarts from 'echarts'

// 修改 el-dialog 默认点击遮照不关闭
ElementUI.Dialog.props.closeOnClickModal.default = false;

import XLSX from 'xlsx'
import FileSaver from 'file-save';
Vue.prototype.XLSX = XLSX
Vue.prototype.FileSaver = FileSaver

Vue.prototype.$echarts = echarts//挂载到vue实例，方便全局使用
Vue.config.productionTip = false
Vue.use(ElementUI);


import VueClipBoard from 'vue-clipboard2'
Vue.use(VueClipBoard)

// 测试环境
//  '当前环境',process.env.NODE_ENV)
//  '当前后端环境',process.env.VUE_APP_SERVE)

// 引入全局样式
import '@/styles/index.less'
import '@/styles/public.less'

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
